// Consult Articles component
import React from "react";
import '../styles/ConsultArticles.css';

function ConsultArticles (){

    return (
        <div className="consult-articles-component">
            <div className="consult-articles">
                <h2>Boost Your Business</h2>
                {/* Articles container */}
                {/* <div className="articles-container">
                
                    {articles.map((article) => (
                        <div className="article-card" key={article.id}>
                            <img src={`https://signifide-website-backend.onrender.com${article.article_image}`} alt={article.article_topic}/>
                            <p>{article.article_paragraph_1}</p>
                            <p>{article.article_paragraph_2}</p>
                        </div>
                    ))}
                </div> */}
                <div className="articles-container">
                {/* Each article card */}
                    <div className="article-card">
                        <img src="/images/gig-economy.jpeg" alt="Gig economy consult"/>
                        <p>KindaGigz connects you directly with clients using geolocation, giving you greater visibility and real job opportunities? Unlike general platforms, we offer verified profiles, real-time job matching, and free skills training to boost your earnings. Don’t miss out—join today!</p>
                        <p>KindaGigz provides real-time gig economy insights, including workforce trends, skills demand, and pricing data? Our analytics drive smarter hiring and business decisions, making KindaGigz a high-growth investment in Africa’s digital employment future.</p>
                    </div>
                    <div className="article-card">
                        <img src="/images/kindatrade-did-you-know.png" alt="Kindatrade consult"/>
                        <p>Did you know that inefficient distribution and speculative stocking lead to significant losses due to unsold inventory, expired products, and unpredictable demand?</p>
                        <p>KindaTrade eliminates guesswork by enabling real-time order tracking, pre-orders, and demand forecasting, ensuring you only stock what sells. Reduce wastage, streamline deliveries, and maximize profitability with data-driven last-mile distribution for FMCG, farm inputs, and pharmaceuticals.</p>
                    </div>
                    <div className="article-card">
                        <img src="/images/erp-and-production-3.jpeg" alt="Kindatech consult"/>
                        <p>Did you know that inefficient business processes, lack of financial visibility, and limited market access slow down SME growth?</p>
                        <p>KindaTech provides an all-in-one digital solution that helps you streamline operations, manage inventory, automate financial records, and access financing opportunities. Whether you’re a retailer, manufacturer, or distributor, KindaTech empowers you to scale efficiently, reduce costs, and increase profitability with data-driven insights and seamless integration.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConsultArticles;